<template>
  <ContactSection />
</template>

<script>
import ContactSection from '../components/sections/ContactSection.vue'

export default {
  name: 'ContactPage',
  components: {
    ContactSection
  }
}
</script>
